import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const emojiMap = {
    'R': '🔴',
    'Y': '🟡',
    'B': '🔵',
    'G': '🟢'
};

const defaultDataString = "G6 B5 B8 G4 G1 B6 B4 G5 G8 B1 B2 G3 Y1 R1 R4 Y6 Y3 R9 R6 Y7 Y8 R2 G9 B7 Y5 R8 B9 G7 Y4 R5 Y9|1 R7|27 Y2|1 R3|2 G2|1 B3|2";

const Crystalogram = ({ dataString = defaultDataString, title = "Поиск друзей" }) => {
    const { t } = useTranslation();
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [hoveredIndex] = useState(null);

    const parsedData = useMemo(() => {
        return dataString.split(' ').map(item => {
            const [colorCount] = item.split('|');
            const color = colorCount[0];
            const count = parseInt(colorCount.slice(1));
            return { color, count };
        });
    }, [dataString]);

    const selectedInfo = hoveredIndex !== null ? parsedData[hoveredIndex] : parsedData[highlightedIndex];

    const getSphereText = (color) => t(`crystalogram.sphere_${color.toLowerCase()}`);
    const getTypeText = (count) => t(`crystalogram.type_${count}`);
    const getExamplesText = (color, count) => t(`crystalogram.examples_${color.toLowerCase()}${count}`);

    return (
        <div>
            <h2 className="text-2xl font-bold text-white mb-4">{title}</h2>

            <div className="bg-white bg-opacity-30 rounded-lg p-4 mb-6">
                <h3 className="text-xl font-semibold text-white mb-2">{t('crystalogram.info')}</h3>
                <p className="text-white mb-2"><strong>{t('crystalogram.sphere')}:</strong> {getSphereText(selectedInfo.color)}</p>
                <p className="text-white mb-2"><strong>{t('crystalogram.type')}:</strong> {getTypeText(selectedInfo.count)}</p>
                <p className="text-white"><strong>{t('crystalogram.examples')}:</strong> {getExamplesText(selectedInfo.color, selectedInfo.count)}</p>

                <div className="overflow-x-auto mt-4">
                    <div className="flex flex-nowrap gap-2 min-w-max">
                        {parsedData.map(({ color, count }, index) => (
                            <div
                                key={index}
                                className={`flex flex-col-reverse items-center px-2 py-1 rounded-lg transition-colors duration-300 cursor-pointer ${index === highlightedIndex
                                        ? 'bg-white bg-opacity-30 shadow-md'
                                        : 'hover:bg-white hover:bg-opacity-10'
                                    }`}
                                onClick={() => setHighlightedIndex(index)}
                                // Removed onMouseEnter and onMouseLeave
                            >
                                <div className={`text-white text-xs mt-2 ${index === highlightedIndex ? 'font-bold' : ''
                                    }`}>
                                    {count}
                                </div>
                                {[...Array(count)].map((_, i) => (
                                    <div
                                        key={i}
                                        className="text-2xl leading-none my-px transition-transform"
                                        title={`${color}${count}`}
                                    >
                                        {emojiMap[color]}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Crystalogram;